import React, { useState } from "react";
import DataTable from "react-data-table-component";
import Select from "react-select";
import Swal from "sweetalert2";
import {
  Button,
  Card,
  Form,
  Container,
  Row,
  Col,
  Tab,
  Modal,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { tambahCabang, getAllCabang, getAllClient } from "stores";
import { getAllAnggotaCabang } from "stores";
import { Dna } from "react-loader-spinner";
import { getAllWilayah } from "stores";

function ListCabang() {
  const dispatch = useDispatch();
  const wilayah = useSelector((state) => state.dashboardUtamaReducer);
  const cabang = useSelector((state) => state.cabangReducer);
  const storeClient = useSelector((state) => state.clientReducer);
  const auth = useSelector((state) => state.authReducer);
  const [modalCabang, setModalCabang] = React.useState(false);
  const [modalDetail, setModalDetail] = React.useState(false);
  const [namaCabang, setNamaCabang] = React.useState("");
  const [idCabang, setIdCabang] = React.useState("");
  const [pilihClient, setPilihClient] = React.useState(null);
  const [filterClient, setFilterClient] = React.useState(null);
  const [alamat, setAlamat] = React.useState("");
  const [listCabang, setListCabang] = React.useState([]);
  const [listClient, setListClient] = React.useState([]);
  const [idClientCbg, setIdClientCbg] = React.useState("");
  const [detailCabang, setDetailCabang] = React.useState([]);
  const [searchText, setSearchText] = React.useState("");
  const [currentPage, setCurrentPage] = React.useState(1);
  const itemsPerPage = 10;
  const [isLoading, setIsLoading] = React.useState(true);
  const [listWilayah, setListWilayah] = React.useState([]);
  const [idWilayah, setIdWilayah] = React.useState({
    label: "",
    value: "",
  });

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleFilterChange = (selectedOption) => {
    setFilterClient(selectedOption);
    getAllCabang(dispatch, { idClient: selectedOption.value });
  };

  const submitCabang = () => {
    tambahCabang({
      cabang_id: idCabang,
      namaCabang: namaCabang,
      alamat: alamat,
      idClient: idClientCbg,
    })
      .then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          handleModalClose();
          getAllCabang(dispatch, { idClient: "" });
        } else if (response.data.status === 403) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      })
      .catch((error) => {
        console.log("ERRORRRR", error);
      });
  };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleModalClose = () => {
    setModalCabang(false);
    setPilihClient("");
    setIdClientCbg("");
    setIdCabang("");
    setAlamat("");
    setNamaCabang("");
  };

  React.useEffect(() => {
    let tmp =
      cabang.listCabang &&
      cabang.listCabang.map((val) => {
        return {
          ...val,
          action: (
            <div className="d-flex align-items-center">
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id={`tooltip-detail-${val._id}`}>
                    Detail Cabang
                  </Tooltip>
                }
              >
                <Button
                  className="btn-icon d-flex align-items-center justify-content-center shadow-sm"
                  style={{
                    marginTop: 5,
                    width: "40px",
                    height: "40px",
                    backgroundColor: "#f90203", // Merah BPR Jatim
                    borderRadius: "12px",
                    border: "none",
                    color: "white",
                    transition: "all 0.3s ease",
                    boxShadow: "0 4px 10px rgba(249, 2, 3, 0.2)",
                  }}
                  onClick={() => {
                    setModalDetail(!modalDetail);
                    setDetailCabang(val);
                    getAllAnggotaCabang(dispatch, { idCabang: val._id });
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = "#d60202";
                    e.currentTarget.style.transform = "translateY(-2px)";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = "#f90203";
                    e.currentTarget.style.transform = "translateY(0)";
                  }}
                >
                  <i
                    className="fas fa-info-circle"
                    style={{ fontSize: "18px" }}
                  ></i>
                </Button>
              </OverlayTrigger>
            </div>
          ),
        };
      });
    setListCabang(tmp);
  }, [cabang.listCabang, modalDetail]);

  React.useEffect(() => {
    let tmp = [
      {
        value: "",
        isDisabled: true,
      },
    ];
    storeClient.listClient &&
      storeClient.listClient.map((val) => {
        tmp.push({
          value: val._id,
          label: val.namaClient,
        });
      });

    setListClient(tmp);
  }, [storeClient.listClient]);

  const customStyles = {
    table: {
      style: {
        backgroundColor: "#ffffff",
      },
    },
    headRow: {
      style: {
        backgroundColor: "#f1f5f9", // Abu-abu biru modern
        minHeight: "55px",
        borderTop: "1px solid #e2e8f0",
        borderBottom: "2px solid #e2e8f0",
      },
    },
    headCells: {
      style: {
        fontSize: "13px",
        fontWeight: "800",
        textTransform: "uppercase",
        color: "#475569",
        justifyContent: "flex-start", // Lurus Kiri
        paddingLeft: "20px",
      },
    },
    rows: {
      style: {
        minHeight: "70px", // Row lebih tinggi agar teks jumbo tidak sesak
        "&:not(:last-of-type)": {
          borderBottom: "1px solid #f1f5f9",
        },
        "&:hover": {
          backgroundColor: "#f8fafc",
          transition: "0.2s ease",
        },
      },
    },
    cells: {
      style: {
        fontSize: "14px",
        color: "#334155",
        justifyContent: "flex-start", // Lurus Kiri
        paddingLeft: "20px",
      },
    },
  };

  const colCabang = [
    {
      name: "NO",
      width: "70px",
      center: false,
      cell: (row, index) => (
        <span className="fw-800 text-muted ml-1" style={{ fontSize: "14px" }}>
          {(currentPage - 1) * itemsPerPage + index + 1}
        </span>
      ),
    },
    {
      name: "KODE",
      width: "120px",
      center: false,
      cell: (row) => (
        <div className="ml-1">
          <span
            className="badge bg-light text-dark border fw-800 shadow-sm"
            style={{
              padding: "8px 12px",
              borderRadius: "10px",
              fontSize: "13px",
              letterSpacing: "0.5px",
            }}
          >
            {row.cabang_id}
          </span>
        </div>
      ),
    },
    {
      name: "NAMA UNIT CABANG",
      minWidth: "250px",
      center: false,
      cell: (row) => (
        <div className="d-flex align-items-center ml-1 py-2">
          <div
            className="mr-3 d-flex align-items-center justify-content-center rounded-lg"
            style={{
              width: "38px",
              height: "38px",
              background: "linear-gradient(135deg, #f90203 0%, #2e3192 100%)",
              color: "white",
              fontSize: "14px",
            }}
          >
            <i className="fas fa-building"></i>
          </div>
          <span className="fw-900 text-dark" style={{ fontSize: "16px" }}>
            {row.namaCabang}
          </span>
        </div>
      ),
    },
    {
      name: "WILAYAH",
      minWidth: "180px",
      center: false,
      cell: (row) => (
        <div
          className="ml-1 fw-800 text-dark d-flex align-items-center"
          style={{ fontSize: "14px" }}
        >
          <i className="fas fa-map-marker-alt mr-2 text-danger"></i>
          {row.wilayah}
        </div>
      ),
    },
    {
      name: "CLIENT BPD",
      minWidth: "200px",
      center: false,
      cell: (row) => (
        <div className="ml-1">
          <span
            className="badge px-3 py-2 fw-800 bg-light text-primary border-primary"
            style={{
              borderRadius: "8px",
              fontSize: "12px",
              border: "1px solid",
            }}
          >
            <i className="fas fa-university mr-2"></i>
            {row.client}
          </span>
        </div>
      ),
    },
    {
      name: "AKSI",
      minWidth: "60px",
      center: false,
      cell: (row) => row.action,
    },
  ];

  React.useEffect(() => {
    let tmp = [];
    wilayah.allWilayah &&
      wilayah.allWilayah.map((val) => {
        // console.log(val, "VAL WILAYAH");
        tmp.push({
          value: val._id,
          label: val.namaWilayah,
        });
      });
    setListWilayah(tmp);
    let Obj = wilayah.allWilayah.find((x) => x.namaWilayah === "Gorontalo");
    // setIdWilayah({ value: Obj._id, label: Obj.namaWilayah });
    // console.log(Obj, ">>>>>>>>>>>>>>>>");
  }, [wilayah.allWilayah]);

  React.useEffect(() => {
    getAllWilayah(dispatch).then((response) => {
      // const dataCabang = response.data;
      // setTotalCbg(dataCabang);
    });
  }, []);

  React.useEffect(() => {
    getAllCabang(dispatch, { idWilayah: idWilayah.value })
      .then(() => {
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
    getAllClient(dispatch);
  }, [idWilayah]);

  return (
    <>
      <Modal
        size="lg"
        show={modalDetail}
        onHide={() => setModalDetail(!modalDetail)}
        centered
        contentClassName="border-0 shadow-xl"
      >
        <Modal.Header closeButton className="border-0 pb-0"></Modal.Header>
        <Modal.Body className="px-5 pb-5">
          <div className="text-center mb-4">
            <div
              className="p-3 d-inline-block mb-3 shadow-sm"
              style={{
                background: "linear-gradient(135deg, #2e3192 0%, #1e293b 100%)",
                borderRadius: "50%",
                color: "white",
              }}
            >
              <i
                className="fas fa-university fa-2x"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  margin: 0,
                  padding: 0,
                  lineHeight: 1,
                  textAlign: "center",
                }}
              ></i>
            </div>
            <h3 className="font-weight-bold m-0 text-dark">
              DETAIL UNIT CABANG
            </h3>
            <p className="text-muted small">
              Informasi lengkap struktur organisasi cabang
            </p>
          </div>

          <div className="bg-light p-4 rounded-xl border shadow-inner">
            {/* INFO UTAMA */}
            <Row className="mb-3 border-bottom pb-3">
              <Col md="6">
                <label className="small fw-800 text-muted text-uppercase d-block">
                  Nama BPD / Client
                </label>
                <span className="h5 font-weight-bold text-primary">
                  {detailCabang.client}
                </span>
              </Col>
              <Col md="6">
                <label className="small fw-800 text-muted text-uppercase d-block">
                  Nama Cabang
                </label>
                <span className="h5 font-weight-bold text-dark">
                  {detailCabang.namaCabang}
                </span>
              </Col>
            </Row>

            {/* STRUKTUR ANGGOTA */}
            <Row>
              {/* AREA MANAGER */}
              <Col md="4" className="border-right">
                <label className="small fw-800 text-danger text-uppercase mb-2 d-block">
                  <i className="fas fa-user-tie mr-2"></i>Area Manager
                </label>
                <ul className="list-unstyled">
                  {cabang.listAllAnggotaCabang.listAreaManager?.length > 0 ? (
                    cabang.listAllAnggotaCabang.listAreaManager.map((val) => (
                      <li
                        key={val.namaAreaManager}
                        className="fw-700 text-dark py-1 border-bottom-dashed small"
                      >
                        {val.namaAreaManager}
                      </li>
                    ))
                  ) : (
                    <li className="text-muted small italic">Kosong</li>
                  )}
                </ul>
              </Col>

              {/* SUPERVISOR */}
              <Col md="4" className="border-right">
                <label className="small fw-800 text-primary text-uppercase mb-2 d-block">
                  <i className="fas fa-user-shield mr-2"></i>Supervisor
                </label>
                <ul className="list-unstyled">
                  {cabang.listAllAnggotaCabang.listSupervisor?.length > 0 ? (
                    cabang.listAllAnggotaCabang.listSupervisor.map((val) => (
                      <li
                        key={val.namaSupervisor}
                        className="fw-700 text-dark py-1 border-bottom-dashed small"
                      >
                        {val.namaSupervisor}
                      </li>
                    ))
                  ) : (
                    <li className="text-muted small italic">Kosong</li>
                  )}
                </ul>
              </Col>

              {/* MARKETING */}
              <Col md="4">
                <label className="small fw-800 text-success text-uppercase mb-2 d-block">
                  <i className="fas fa-users mr-2"></i>Marketing
                </label>
                <ul
                  className="list-unstyled"
                  style={{ maxHeight: "150px", overflowY: "auto" }}
                >
                  {cabang.listAllAnggotaCabang.listMarketing?.length > 0 ? (
                    cabang.listAllAnggotaCabang.listMarketing.map((val) => (
                      <li
                        key={val.namaMarketing}
                        className="fw-700 text-dark py-1 border-bottom-dashed small"
                      >
                        {val.namaMarketing}
                      </li>
                    ))
                  ) : (
                    <li className="text-muted small italic">Kosong</li>
                  )}
                </ul>
              </Col>
            </Row>
          </div>

          <Button
            className="btn-block mt-4 py-3 border-0 fw-900 shadow"
            style={{
              background: "#2e3192",
              borderRadius: "12px",
              color: "white",
            }}
            onClick={() => setModalDetail(false)}
          >
            TUTUP DETAIL
          </Button>
        </Modal.Body>
      </Modal>

      <Modal
        size="lg"
        show={modalCabang}
        onHide={() => {
          handleModalClose();
          setModalCabang(false);
        }}
        centered
        contentClassName="border-0 shadow-2xl"
      >
        <Modal.Header closeButton className="border-0 pb-0"></Modal.Header>
        <Modal.Body className="px-5 pb-5">
          <div className="d-flex align-items-center mb-4">
            <div
              className="p-3 mr-3 shadow-sm"
              style={{
                background: "linear-gradient(135deg, #f90203 0%, #2e3192 100%)",
                borderRadius: "15px",
                color: "white",
              }}
            >
              <i className="fas fa-plus-circle fa-lg"></i>
            </div>
            <div>
              <h3 className="m-0 font-weight-bold text-dark">
                TAMBAH CABANG BARU
              </h3>
              <p className="m-0 text-muted">
                Input data unit kerja cabang BPR JATIM
              </p>
            </div>
          </div>

          <Form>
            <Row>
              <Col md="4">
                <Form.Group className="mb-3">
                  <label className="small fw-800 text-dark text-uppercase">
                    ID Cabang
                  </label>
                  <Form.Control
                    className="border-0 shadow-sm bg-light fw-700"
                    style={{ height: "50px", borderRadius: "12px" }}
                    placeholder="Contoh: 001"
                    onChange={(e) => setIdCabang(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md="8">
                <Form.Group className="mb-3">
                  <label className="small fw-800 text-dark text-uppercase">
                    Nama Cabang
                  </label>
                  <Form.Control
                    className="border-0 shadow-sm bg-light fw-700"
                    style={{ height: "50px", borderRadius: "12px" }}
                    placeholder="Masukkan Nama Cabang"
                    onChange={(e) => setNamaCabang(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Form.Group className="mb-3">
              <label className="small fw-800 text-dark text-uppercase">
                Alamat Cabang
              </label>
              <Form.Control
                as="textarea"
                rows={3}
                className="border-0 shadow-sm bg-light fw-600"
                style={{ borderRadius: "12px", padding: "15px" }}
                placeholder="Tuliskan alamat lengkap cabang..."
                onChange={(e) => setAlamat(e.target.value)}
              />
            </Form.Group>

            {auth.role === "super admin" && (
              <Form.Group className="mb-4">
                <label className="small fw-800 text-dark text-uppercase">
                  Pilih Client BPD
                </label>
                <Select
                  classNamePrefix="react-select"
                  value={pilihClient}
                  onChange={(v) => {
                    setPilihClient(v);
                    setIdClientCbg(v.value);
                  }}
                  options={listClient}
                  placeholder="-- Pilih Client --"
                  styles={{
                    control: (b) => ({
                      ...b,
                      borderRadius: "12px",
                      minHeight: "50px",
                    }),
                  }}
                />
              </Form.Group>
            )}

            {/* STACKED ACTION BUTTONS */}
            <div className="mt-4 pt-2 text-center">
              <Button
                className="btn-block py-3 border-0 fw-900 shadow-lg mb-3"
                style={{
                  background:
                    "linear-gradient(135deg, #f90203 0%, #2e3192 100%)",
                  borderRadius: "15px",
                  color: "white",
                  fontSize: "16px",
                }}
                onClick={submitCabang}
              >
                SIMPAN CABANG
              </Button>
              <Button
                variant="link"
                className="text-muted fw-700 text-decoration-none"
                onClick={() => {
                  handleModalClose();
                  setModalCabang(false);
                }}
              >
                Batalkan & Keluar
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <Container fluid>
        <Row>
          <Col md="12">
            <Card
              className="border-0 shadow-sm"
              style={{ borderRadius: "20px", overflow: "hidden" }}
            >
              <Card.Header className="bg-white border-0 pt-4 px-4">
                <div className="d-flex align-items-center">
                  <div
                    className="p-2 mr-3"
                    style={{ background: "#f90203", borderRadius: "12px" }}
                  >
                    <i className="fas fa-code-branch text-white"></i>
                  </div>
                  <Card.Title
                    as="h3"
                    className="font-weight-bold m-0"
                    style={{
                      color: "#1e293b",
                      textTransform: "uppercase",
                      letterSpacing: "1px",
                    }}
                  >
                    Manajemen Daftar Cabang
                  </Card.Title>
                </div>
                <hr className="mt-3 mb-0" style={{ opacity: "0.08" }} />
              </Card.Header>

              <Card.Body className="px-4 pb-4">
                {/* WRAPPER FILTER & ACTION - LEBIH RAMPING & SEJAJAR */}
                <div
                  className="d-flex flex-wrap align-items-center justify-content-between mb-4 p-3 shadow-sm border"
                  style={{ borderRadius: "16px", backgroundColor: "#ffffff" }}
                >
                  {/* SISI KIRI: AKSI UTAMA */}
                  <div className="flex-grow-1 mb-2 mb-lg-0">
                    {(auth.role === "super admin" || auth.role === "admin") && (
                      <Button
                        className="btn-fill d-flex align-items-center justify-content-center border-0 shadow-sm"
                        style={{
                          background:
                            "linear-gradient(135deg, #f90203 0%, #ff4d4d 100%)",
                          fontWeight: "900",
                          borderRadius: "12px",
                          padding: "12px 24px",
                          fontSize: "13px",
                          letterSpacing: "0.5px",
                        }}
                        onClick={() => setModalCabang(!modalCabang)}
                      >
                        <i className="fas fa-plus-circle mr-2"></i> TAMBAH
                        CABANG
                      </Button>
                    )}
                  </div>

                  {/* SISI KANAN: GROUP FILTER & SEARCH */}
                  <div
                    className="d-flex flex-wrap align-items-center"
                    style={{ gap: "12px" }}
                  >
                    {/* FILTER WILAYAH - LEBIH COMPACT */}
                    {/* <div style={{ minWidth: "220px" }}>
                      <Select
                        className="react-select primary shadow-none"
                        classNamePrefix="react-select"
                        defaultValue={{ label: "Semua Wilayah", value: "" }}
                        onChange={(value) => setIdWilayah(value)}
                        options={listWilayah}
                        placeholder="Wilayah..."
                        styles={{
                          control: (base) => ({
                            ...base,
                            borderRadius: "12px",
                            height: "45px",
                            border: "1px solid #e2e8f0",
                            backgroundColor: "#f8fafc",
                            fontWeight: "600",
                            fontSize: "14px",
                          }),
                        }}
                      />
                    </div> */}

                    {/* PENCARIAN CEPAT - INTEGRATED STYLE */}
                    <div style={{ minWidth: "280px" }}>
                      <InputGroup
                        className="border rounded-lg overflow-hidden"
                        style={{
                          borderRadius: "12px",
                          backgroundColor: "#f8fafc",
                          border: "1px solid #e2e8f0",
                        }}
                      >
                        <InputGroup.Prepend>
                          <InputGroup.Text className="bg-transparent border-0 pr-0 pl-3">
                            <i
                              className="fas fa-search text-muted"
                              style={{ fontSize: "14px" }}
                            ></i>
                          </InputGroup.Text>
                        </InputGroup.Prepend>
                        <Form.Control
                          className="border-0 bg-transparent fw-600"
                          style={{
                            height: "45px",
                            fontSize: "14px",
                            paddingLeft: "10px",
                          }}
                          type="text"
                          value={searchText}
                          onChange={handleSearch}
                          placeholder="Cari Cabang..."
                        />
                      </InputGroup>
                    </div>
                  </div>
                </div>

                {/* TABEL AREA */}
                {isLoading ? (
                  <div
                    className="loader-container d-flex flex-column align-items-center justify-content-center py-5"
                    style={{
                      background: "#f8fafc",
                      borderRadius: "20px",
                      minHeight: "35vh",
                    }}
                  >
                    <Dna visible={true} height="80" width="80" />
                    <p className="mt-2 text-muted fw-bold">
                      MENYIAPKAN DATA...
                    </p>
                  </div>
                ) : (
                  <div className="table-responsive rounded-xl shadow-sm border bg-white">
                    <DataTable
                      columns={colCabang}
                      data={listCabang.filter(
                        (row) =>
                          row.cabang_id
                            .toLowerCase()
                            .includes(searchText.toLowerCase()) ||
                          row.namaCabang
                            .toLowerCase()
                            .includes(searchText.toLowerCase()),
                      )}
                      customStyles={customStyles}
                      pagination
                      paginationPerPage={itemsPerPage}
                      onChangePage={handlePageChange}
                      highlightOnHover
                    />
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ListCabang;
